/*
*
* File JS componente Block Products
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-products.scss';
import Swiper from 'swiper';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockPorducts = () => {
    
    const products = document.querySelector('.block-products');
    if(!products ) return;

    const productsSwiper = new Swiper('#block-products__swiper', {
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        breakpoints: {
            300: {
                slidesPerView: 1.2,
                spaceBetween: 30, 
            },
            768: {
                slidesPerView: 2.5,
                spaceBetween: 50, 
                },
            1025: {
                slidesPerView: 3.5,
                spaceBetween: 50, 

            },
    
        }
    });

}

export default blockPorducts;

//--------------------------------------------------------------------//

